export const teachingFocusStepCopy = {
  title: "What do you teach?",
  subtitle: "Tell us a bit about your focus so we can personalize your experience.",
  gradesHeading: "Grades",
  subjectsHeading: "Subjects",
  curriculumHeading: "Select your curriculum",
  backLabel: "Back",
  nextLabel: "Next Step",
};

export const gradeOptions = [
  { id: "k-5", label: "K-5" },
  { id: "6-8", label: "6-8" },
  { id: "9-10", label: "9-10" },
  { id: "11-12", label: "11-12" },
  { id: "higher-ed", label: "Higher Ed" },
];
